import { User } from '@codetrix-studio/capacitor-google-auth';
import { GoogleAuthProvider, User as FirebaseUser } from 'firebase/auth';

export const isUserEqual = (googleUser: User, firebaseUser: FirebaseUser) => {
  if (firebaseUser) {
    const providerData = firebaseUser.providerData;
    for (const provider of providerData) {
      if (
        provider.providerId === GoogleAuthProvider.PROVIDER_ID &&
        provider.uid === googleUser.id
      ) {
        // We don't need to reAuth the Firebase connection.
        return true;
      }
    }
  }
  return false;
};
